import styled from 'styled-components'
import { NavigationControl } from 'react-map-gl'

const StyledNavigationControl = styled(NavigationControl).attrs({
  showCompass: false,
})`
  position: absolute;
  top: ${props => props.theme.gutter}px;
  left: ${props => props.theme.gutter}px;
`

export default StyledNavigationControl
